import hatImg from "../../images/buds.png";
import shoeImg from "../../images/watch.png";
import arrival from "../../images/prod.png";
const HomeSecondSection = () => {
  return (
    <div className="hidden lg:grid grid-cols-2 gap-3 px-[50px] mb-[70px] h-[60vh]">
      <div
        id="box"
        className="row-start-1 row-end-3 bg-red-600 col-start-1 col-end-2 overflow-hidden rounded-[20px] relative"
      >
        <img
          id="box-img"
          src={arrival}
          alt=""
          className="h-[100%] w-[100%] object-fill transition-all duration-500 ease-in-out"
        />
        <div className="absolute top-0 left-0 h-[100%] w-[100%] bg-[#0000005b]"></div>
        <div className="absolute top-[60%] left-[5%] text-white">
          <h2 className="text-[20px] font-[700]">NEW COLLECTION</h2>
          <div className="flex items-center gap-1">
            <h1 className="text-[30px] font-[600]">20</h1>
            <span className="font-[600]">
              % <br />
              OFF
            </span>
          </div>
          {/* <button className="text-black bg-white px-[10px] py-[5px] rounded-[5px] text-[14px] font-[600] mt-[10px]">
            VIEW OFFER
          </button> */}
        </div>
      </div>
      <div
        id="box"
        className="row-start-1 row-end-2 bg-[#f3efff] col-start-2 col-end-3 overflow-hidden rounded-[20px] relative"
      >
        <div className="absolute top-[20%] left-[5%] text-black">
          <h2 className="text-[20px] font-[700]">NEW COLLECTION</h2>
          <div className="flex items-center gap-1">
            <h1 className="text-[30px] font-[600]">20</h1>
            <span className="font-[600]">
              % <br />
              OFF
            </span>
          </div>
          {/* <button className="text-black bg-white px-[10px] py-[5px] rounded-[5px] text-[14px] font-[600] mt-[10px]">
            VIEW OFFER
          </button> */}
        </div>
        <img
          id="box-img"
          className="absolute top-1 left-[70%] h-[200px] transition-all duration-500 ease-in-out"
          src={hatImg}
          alt=""
        />
      </div>
      <div
        id="box"
        className="row-start-2 row-end-3 bg-[#ffebbe] col-start-2 col-end-3 overflow-hidden rounded-[20px] relative"
      >
        <div className="absolute top-[20%] left-[5%] text-black">
          <h2 className="text-[20px] font-[700]">NEW COLLECTION</h2>
          <div className="flex items-center gap-1">
            <h1 className="text-[30px] font-[600]">20</h1>
            <span className="font-[600]">
              % <br />
              OFF
            </span>
          </div>
          {/* <button className="text-black bg-white px-[10px] py-[5px] rounded-[5px] text-[14px] font-[600] mt-[10px]">
            VIEW OFFER
          </button> */}
        </div>
        <img
          id="box-img"
          className="absolute top-1 left-[70%] h-[200px] transition-all duration-500 ease-in-out"
          src={shoeImg}
          alt=""
        />
      </div>
      {/* <div className="w-[100%] md:w-[55%] rounded-[25px] lg:overflow-hidden relative mb-[-70px] lg:mb:[0px]">
        <div className="text-white relative top-[50%] left-[5%] z-20">
          <h6 className="text-[16px] font-[600] mt-[90px] md:mt-[-50px] lg:mt-[0px]">
            NEW TOYS COLLECTION
          </h6>
          <div className="flex items-start mt-[5px]">
            <h3 className="text-[45px] font-[700] mr-[10px]">20</h3>
            <div className="font-[600] relative top-[9px]">
              <p>%</p>
              <p>OFF</p>
            </div>
          </div>
          <button className="bg-white text-black py-[10px] px-[20px] rounded-[5px] mt-[10px] transition-all duration-200 hover:bg-amber-500">
            VIEW OFFER <i class="fa-solid fa-arrow-up-right-from-square"></i>
          </button>
        </div>
        <div
          className="rounded-[10px] transition-transform duration-500 hover:scale-110 bg-cover bg-center bg-no-repeat absolute inset-0 mt-[40px] lg:mt-0 px-[40px] pb-[40px] bg-[#00000042] bg-blend-darken h-[30vh] lg:h-[85%]"
          id="dinosaur"
        ></div>
      </div>
      <div className="w-[100%] md:w-[50%] lg:w-[30%] flex flex-col gap-8 mt-[30px]">
        <div
          className="h-[50%] w-[100%] lg:w-[125%] bg-[#f3efff] rounded-[25px] px-[30px] py-[20px] flex items-center justify-between"
          id="second-section-box"
        >
          <div>
            <h6 className="text-[16px] font-[600]">NEW SHOES COLLECTION</h6>
            <div className="flex items-start mt-[5px]">
              <h3 className="text-[45px] font-[700] mr-[10px]">10</h3>
              <div className="font-[600] relative top-[9px]">
                <p>%</p>
                <p>OFF</p>
              </div>
            </div>
            <button className="bg-white text-black py-[10px] px-[20px] rounded-[5px] mt-[10px] transition-all duration-200 hover:bg-[#b29cf4]">
              VIEW OFFER <i class="fa-solid fa-arrow-up-right-from-square"></i>
            </button>
          </div>
          <img
            src={shoeImg}
            className="h-[130px] transition-all duration-500"
            id="shoe-box"
            alt=""
          />
        </div>
        <div
          className="h-[50%] w-[100%] lg:w-[125%] bg-[#FFEBBE] rounded-[25px] px-[30px] py-[20px] flex items-center justify-between"
          id="second-section-box"
        >
          <div>
            <h6 className="text-[16px] font-[600]">NEW HATS COLLECTION</h6>
            <div className="flex items-start mt-[5px]">
              <h3 className="text-[45px] font-[700] mr-[10px]">12</h3>
              <div className="font-[600] relative top-[9px]">
                <p>%</p>
                <p>OFF</p>
              </div>
            </div>
            <button className="bg-white text-black py-[10px] px-[20px] rounded-[5px] mt-[10px] transition-all duration-200 hover:bg-amber-500 hover:text-black">
              VIEW OFFER <i class="fa-solid fa-arrow-up-right-from-square"></i>
            </button>
          </div>
          <img
            src={hatImg}
            className="h-[130px] transition-all duration-500"
            id="shoe-box"
            alt=""
          />
        </div>
      </div> */}
    </div>
  );
};

export default HomeSecondSection;
